// Global constants
export const SET_SELECTION_PROPS = "selection/SET_SELECTION_PROPS";
export const RESET_SELECTION_PROPS = "selection/RESET_SELECTION_PROPS";

// Mutation constants
export const SET_SELECTION_PROPS_MUT = "SET_SELECTION_PROPS_MUT";
export const RESET_SELECTION_PROPS_MUT = "RESET_SELECTION_PROPS_MUT";
